import { useState, useEffect } from 'react';
import { buildBlockQuery } from '../utils/influenceBlocks';

const API_BASE_URL = process.env.REACT_APP_API_URL || '';

// state: {loading, error, data}. data.available === false is a normal answer (custom range, no row yet).
// `enabled: false` skips the request (cutover off, or the page has no period yet).
export default function useInfluenceBlock(path, params, enabled = true) {
  const query = buildBlockQuery(params || {});
  const [state, setState] = useState({ loading: enabled, error: null, data: null, query });
  useEffect(() => {
    if (!enabled) {
      setState({ loading: false, error: null, data: null, query });
      return undefined;
    }
    let live = true;
    setState((s) => ({ ...s, loading: true, error: null, query }));
    fetch(`${API_BASE_URL}${path}?${query}`, { credentials: 'include' })
      .then((r) => { if (!r.ok) throw new Error(`HTTP ${r.status}`); return r.json(); })
      .then((data) => { if (live) setState({ loading: false, error: null, data, query }); })
      .catch((e) => { if (live) setState({ loading: false, error: e.message, data: null, query }); });
    return () => { live = false; };
  }, [path, query, enabled]);
  // the render before the effect runs still holds the previous filters' answer: never hand it out for the new query
  return state.query === query || !enabled ? state : { loading: true, error: null, data: null, query };
}
